import { create } from 'zustand'

const API_BASE = import.meta.env.DEV ? 'http://localhost:3001' : ''

export const useBrechasStore = create((set, get) => ({
  brechas: [],
  currentBrecha: null,
  isLoading: false,
  error: null,

  // Fetch brechas for a specific criterio
  fetchBrechasByCriterio: async (criterioId, token) => {
    set({ isLoading: true, error: null })
    try {
      const response = await fetch(`${API_BASE}/api/brechas/${criterioId}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })

      if (response.status === 401) {
        // Token inválido o expirado - redirigir al login
        set({ error: 'Sesión expirada. Por favor, inicia sesión nuevamente.', isLoading: false })
        // Limpiar el store de auth
        const { logout } = await import('./authStore')
        logout()
        window.location.href = '/login'
        return
      }

      if (!response.ok) {
        const error = await response.json()
        throw new Error(error.error || 'Error al cargar brechas')
      }

      const data = await response.json()
      set({ brechas: data.brechas, isLoading: false })
      return data.brechas
    } catch (error) {
      set({ error: error.message, isLoading: false })
      throw error
    }
  },

  // Fetch detail of a specific brecha
  fetchBrechaDetail: async (brechaId, token) => {
    set({ isLoading: true, error: null })
    try {
      const response = await fetch(`${API_BASE}/api/brechas/detail/${brechaId}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })

      if (!response.ok) {
        const error = await response.json()
        throw new Error(error.error || 'Error al cargar detalle de brecha')
      }

      const data = await response.json()
      set({ currentBrecha: data.brecha, isLoading: false })
      return data.brecha
    } catch (error) {
      set({ error: error.message, isLoading: false })
      throw error
    }
  },

  // Create a new brecha
  createBrecha: async (brechaData, token) => {
    set({ isLoading: true, error: null })
    try {
      const response = await fetch(`${API_BASE}/api/brechas/create`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(brechaData)
      })

      if (response.status === 401) {
        set({ error: 'Sesión expirada. Por favor, inicia sesión nuevamente.', isLoading: false })
        const { logout } = await import('./authStore')
        logout()
        window.location.href = '/login'
        return
      }

      if (!response.ok) {
        const error = await response.json()
        throw new Error(error.error || 'Error al crear brecha')
      }

      const data = await response.json()
      
      // Add new brecha to the list
      set(state => ({
        brechas: [data.brecha, ...state.brechas],
        isLoading: false
      }))

      return data.brecha
    } catch (error) {
      set({ error: error.message, isLoading: false })
      throw error
    }
  },

  // Update brecha estado
  updateBrechaEstado: async (brechaId, estado, fechaResolucion, token) => {
    set({ isLoading: true, error: null })
    try {
      const response = await fetch(`${API_BASE}/api/brechas/update-estado`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          brecha_id: brechaId,
          estado,
          fecha_resolucion: fechaResolucion
        })
      })

      if (!response.ok) {
        const error = await response.json()
        throw new Error(error.error || 'Error al actualizar estado')
      }

      const data = await response.json()
      
      // Update brecha in the list
      set(state => ({
        brechas: state.brechas.map(b => 
          b.id === brechaId ? data.brecha : b
        ),
        currentBrecha: state.currentBrecha?.id === brechaId 
          ? data.brecha 
          : state.currentBrecha,
        isLoading: false
      }))

      return data.brecha
    } catch (error) {
      set({ error: error.message, isLoading: false })
      throw error
    }
  },

  // Clear current brecha
  clearCurrentBrecha: () => set({ currentBrecha: null }),

  // Clear error
  clearError: () => set({ error: null })
}))
